import { Box, Heading } from "theme-ui";
import { SplitScreen, SiteLogo } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  Box,
  Heading,
  SplitScreen,
  SiteLogo,
  React
};